<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import BrandsUnlocked from './BrandsUnlocked.svelte';
  import AddRecPrompt from './AddRecPrompt.svelte';

  const dispatch = createEventDispatcher();

  export let mobile = false;

  let brandsActive = false;
  export let showAddBrandsModal = true;
  let showAddRecPromptModal = false;
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  * :global(.invite-flow-welcome-modal-title) {
    font-size: 42px;
    line-height: 38px;
    font-weight: 800;
    text-transform: uppercase;
    color: #717171;
  }

  .add-brands-step {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: calc(100dvh - 114px);

    .content-container {
      flex: 1;
      max-width: 460px;
      width: 100%;
      margin: 0 auto;
      padding: 20px;
    }

    .button-container {
      max-width: 440px;
      width: 100%;
      margin: 0 auto;
      padding-bottom: 44px;
    }

    .ui-title {
      font-size: 42px;
      line-height: 38px;
      text-align: center;
      font-weight: 800;
      text-transform: uppercase;
      margin-top: 64px;
      margin-bottom: 16px;
      color: #717171;
    }

    .ui-subtitle {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #7f7f7f;
      margin-bottom: 32px;
    }

    .ui-bonus-header {
      color: #3d3d3d;
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
    }

    .bonus-banner-container {
      line-height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      text-align: left;
      gap: 16px;

      color: $neutral-gray;
      padding: 20px;

      border-radius: 12px;
      border: 1px solid rgba(77, 175, 255, .4);
      background: linear-gradient(90deg, rgba(77, 175, 255, 0.04) -0.14%, rgba(108, 159, 255, 0.04) 14.9%, rgba(123, 153, 255, 0.04) 23.92%, rgba(204, 161, 247, 0.04) 46.99%, rgba(234, 169, 178, 0.04) 64.04%, rgba(249, 173, 143, 0.04) 81.09%, rgba(252, 183, 71, 0.04) 97.13%), #fff;
    }
  }

  .mobile {

    .ui-title {
      margin-top: 32px;
    }
  }

  .skip-btn {
    position: absolute;
    right: 20px;
    top: 40px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #1A1A1A;
    cursor: pointer;

    &:hover {
      color: #3d3d3d;
    }
  }

  .checkbox-container {
    flex-shrink: 0;
    position: relative;
    display: inline-block;
    width: 60px;
    height: 32px;

    .toggler-enabled {
      background-color: #a893f9 !important;
      border-color: #a893f9 !important;
      &:before {
        transform: translateX(24px) !important;
        background: white !important;
      }
    }

    .ui-toggler {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      border: 2px solid #C2C5C4;
      border-radius: 999px;
      transition: 0.4s;
      &:before {
        position: absolute;
        content: '';
        height: 24px;
        width: 24px;
        left: 4px;
        bottom: 2px;
        background-color: #C2C5C4;
        border-radius: 50%;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
  }
  
</style>
<div class="add-brands-step" class:mobile={mobile}>
  <div class="content-container">
    <div class="ui-title national-2-narrow">Brands pay you when people shop your recs</div>

    <div class="bonus-banner-container {mobile ? 'mobile' : ''}"><!--flex and flex direction row-->
      <div>
        <div class="ui-bonus-header">
          Unlock 30k+ brands
        </div>
        <div class="ui-bonus-body">Instantly get approved by 30k+ of your fav brands</div>
      </div>
      
      <div class="checkbox-container">
        <span
          on:click={() => {
            brandsActive = !brandsActive;
            showAddRecPromptModal = true
          }}
          class="ui-toggler"
          class:toggler-enabled={brandsActive} />
      </div>

    </div>
  </div>

  {#if showAddBrandsModal}
    <Modal
      show={true}
      showCloseButton={false}
      allowClose={false}
      fadeInDuration={200}
      closeOnOverlayClick={false}
      containerClass={'invite-flow-welcome-modal'}
    >
      <div slot="content">
        <BrandsUnlocked on:finished={() => showAddBrandsModal = false} />
      </div>
    </Modal>
  {/if}

  {#if showAddRecPromptModal}
    <Modal
      show={true}
      showCloseButton={false}
      allowClose={false}
      closeOnOverlayClick={false}
      fadeInDuration={200}
      containerClass={'invite-flow-welcome-modal'}
    >
      <div slot="content">
        <AddRecPrompt on:finished={() => {
          showAddRecPromptModal = false;
          dispatch('finished');
        }} />
      </div>
    </Modal>
  {/if}
</div>
